import { Dialog, DialogTitle, DialogContent } from '@mui/material'
import Button from '@mui/material/Button'
import { Box } from '@material-ui/core'

export const ConfirmationModal = ({
  frontId,
  handleCloseModal,
  openModal,
  setOpenModal,
}) => {
  return (
    <Dialog fullWidth maxWidth="lg" onClose={handleCloseModal} open={openModal}>
      <DialogTitle
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        Ajouter un ticket
      </DialogTitle>
      <DialogContent sx={{ paddingBottom: 0 }}>
        <p style={{ fontSize: '0.90rem' }}>
          Vous êtes sur le point de créer un ticket dans HelloApp, voulez-vous
          automatiquement le lier à ce ticket Front ?
        </p>
        <p style={{ fontSize: '0.90rem' }}>
          Une fois terminé, pensez à rafraichir l'application après la création
          du ticket.
        </p>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Button
            sx={{ margin: '20px 10px 20px 10px' }}
            variant="contained"
            onClick={() => {
              window.open(
                `https://syndic.manda.fr/tickets/create?front_ticket_ids=${frontId}`,
                '_blank'
              )
              setOpenModal(false)
            }}
          >
            Oui
          </Button>
          <Button
            sx={{ margin: '20px 10px 20px 10px' }}
            variant="outlined"
            onClick={() => {
              window.open(`https://syndic.manda.fr/tickets/create`, '_blank')
              setOpenModal(false)
            }}
          >
            Non
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  )
}
